import RatesIcon from '@mui/icons-material/PaidOutlined';
import Container from '@mui/material/Container';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import RatesSection from '@/sections/Rates';

const Rates = () => {
  usePageTitle('Mis tarifas');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title={'Mis tarifas'} mt={5}>
        <RatesIcon fontSize="large" />
      </SectionTitle>
      <RatesSection />
    </Container>
  );
};

export default Rates;
